module.exports = __webpack_public_path__ + "static/media/avataroverview-image.47cf538e.webp";